module.exports = __webpack_public_path__ + "static/media/19.4e53deb8.jpg";